import { Navigate } from 'react-router-dom';
import api from './../api/api';
import { ws, wsAdmin } from './../api/websocketApi';
import MainPage from './MainPage';

const reconnect = (ws) => {
    if (ws.isFullyInitialized()) {
        if (!ws.isConnected()) {
            console.warn(`Connection to ${ws.theUrl} lost, reconnecting...`);
            ws.setShouldReconnectCallbacks(true);
            ws.connect();
        }
    } else {
        // This is needed to solve inifinite loader
        // when app is sent to background when switching from
        // auth to 'main'.
        if (!ws.isConnected()) {
            ws.connect();
        }
    }
};

export default function AuthLoadingPage() {
    const accessToken = localStorage.getItem('accessToken');

    if (!accessToken) {
        return <Navigate to="/login" />;
    } else {
        // Make sure Axios uses current token!
        api.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

        reconnect(ws);
        // TODO only attempt for admin
        reconnect(wsAdmin);
    }

    return <MainPage />;
}
